"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _FlightLand = _interopRequireDefault(require("@material-ui/icons/FlightLand"));
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _Card = _interopRequireDefault(require("../Card"));
var _CardContent = _interopRequireDefault(require("../CardContent"));
var _CardActions = _interopRequireDefault(require("../CardActions"));
var _Button = _interopRequireDefault(require("../Button"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _DatepickerResponsive = _interopRequireDefault(require("../DatepickerResponsive"));
var _Autocomplete = _interopRequireDefault(require("../Autocomplete"));
var _InlineMenu = _interopRequireDefault(require("../InlineMenu"));
var _index = _interopRequireDefault(require("./index.style"));
var _theme = _interopRequireDefault(require("../../theme"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FlightSearch = props => {
  const {
    acOptions = [],
    hideIconOn = [],
    iconTo = /*#__PURE__*/_react.default.createElement(_FlightLand.default, null),
    getSelectedDates = () => {},
    flightToDefault = '',
    menuItems = [],
    labelFrom = 'From',
    labelTo = 'Flying to',
    labelButton = 'Search flights',
    noResultsErrorMessage = "We couldn't find the city/airport you entered",
    placeholderFrom = 'Enter airport name or code',
    selectedDepartureAirport = () => {},
    onSelectedGuests = () => {},
    onSelectedOptions = () => {},
    incomingStartDate,
    incomingEndDate,
    minAvailableDate,
    maxAvailableDate,
    datepickerIcon,
    dividerInputIcon,
    labelDatepicker,
    resetDatesButtonLabel,
    submitDatesButtonLabel,
    placeholderStartDate,
    placeholderEndDate,
    selectedGuests
  } = props;
  const [departureAirport, setDepartureAirport] = (0, _react.useState)(false);
  const classes = (0, _index.default)();
  const isXl = (0, _useMediaQuery.default)(_theme.default.breakpoints.up('xl'));
  const getSelectedValue = value => {
    setDepartureAirport(value);
    selectedDepartureAirport(value);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, /*#__PURE__*/_react.default.createElement(_Card.default, null, /*#__PURE__*/_react.default.createElement(_CardContent.default, {
    className: classes.cardContent
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: isXl ? 4 : 3
  }, /*#__PURE__*/_react.default.createElement(_InlineMenu.default, {
    selectedGuests: value => onSelectedGuests(value),
    selectedOption: onSelectedOptions,
    menuData: menuItems
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    className: classes.gridItem
  }, /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
    getSelectedValue: getSelectedValue,
    getInputLabel: option => "".concat(option.city, " (").concat(option.code, ")"),
    getOptionLabel: option => "".concat(option.name, " (").concat(option.code, ")"),
    noResultsErrorMessage: noResultsErrorMessage,
    placeholder: placeholderFrom,
    label: labelFrom,
    options: acOptions
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    className: classes.gridItem
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    label: labelTo,
    disabled: true,
    title: flightToDefault,
    defaultValue: flightToDefault,
    InputProps: {
      startAdornment: /*#__PURE__*/_react.default.createElement(_core.Hidden, {
        only: hideIconOn
      }, /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start"
      }, iconTo))
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    className: classes.gridItemCalendar
  }, /*#__PURE__*/_react.default.createElement(_DatepickerResponsive.default, {
    onSelectedDates: getSelectedDates,
    incomingStartDate: incomingStartDate,
    incomingEndDate: incomingEndDate,
    minAvailableDate: minAvailableDate,
    maxAvailableDate: maxAvailableDate,
    datepickerIcon: datepickerIcon,
    dividerInputIcon: dividerInputIcon,
    labelDatepicker: labelDatepicker,
    resetDatesButtonLabel: resetDatesButtonLabel,
    submitDatesButtonLabel: submitDatesButtonLabel,
    placeholderStartDate: placeholderStartDate,
    placeholderEndDate: placeholderEndDate
  })))), /*#__PURE__*/_react.default.createElement(_CardActions.default, {
    className: classes.cardActions
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "submit",
    disabled: !departureAirport || (selectedGuests === null || selectedGuests === void 0 ? void 0 : selectedGuests.filter(guest => guest.selected && guest.requiresFlightTicket).length) === 0,
    variant: "contained",
    color: "primary"
  }, labelButton))));
};
var _default = exports.default = FlightSearch;